import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { style: {"height":"1.38rem"} }
const _hoisted_3 = {
  key: 0,
  class: "full-logo"
}
const _hoisted_4 = {
  key: 1,
  class: "tiny-logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_application_left_menu_component = _resolveComponent("application-left-menu-component")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          ref: "leftHolder",
          class: _normalizeClass({'left-holder': true, 'collapsed': _ctx.isMenuCollapsed, 'restored': !_ctx.isMenuCollapsed, 'animation-ready': _ctx.leftMenuAnimationReady})
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.isTinyLogoShown)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "TECHNICAL POINT"))
                : _createCommentVNode("", true),
              (_ctx.isTinyLogoShown)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "T"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_application_left_menu_component, {
              width: _ctx.isMenuCollapsed ? _ctx.collapsedWidth : _ctx.expandedWidth,
              collapsed: _ctx.isMenuCollapsed,
              onCollapse: _ctx.onLeftMenuCollapse,
              "is-authenticated": _ctx.store.getters.isAuthenticated
            }, null, 8, ["width", "collapsed", "onCollapse", "is-authenticated"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_container, {
          class: _normalizeClass({'content-holder': true, 'collapsed': _ctx.isMenuCollapsed, 'restored': !_ctx.isMenuCollapsed})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}